<template>
    <div>
        <div v-if="maintenance_mode" class="siteConstruction text-center py-4 bg-danger text-white position-sticky top-0 w-100">
            {{ maintenance_notice }}
        </div>
        <div :class="{ 'showcartSidebar': isSidebarVisible, 'cartSidebar': true }">
            <Cart  />
        </div>
        <header>
            <div class="container">
                <div class="row align-items-center">
                <div class="col-xl-2">
                    <div class="sitelogo" v-if="header_logo">
                        <router-link to="/"> <img :src="header_logo" class="img-fluid" alt="Logo" /></router-link>
                    </div>
                </div>
                <div class="col-xl-10">
                    <!-- Mobile-only: the full nav (site-menu below) is hidden below
                         768px in favor of the bottom tab bar, which left this side
                         of the header empty on mobile. The currency selector used
                         to live in that bottom bar instead, but it's a fixed,
                         transformed, absolutely-positioned container that Popper
                         (bootstrap-vue's dropdown positioning library) consistently
                         miscalculated against, and dropup never worked there either
                         (see the removed CSS notes). Living here avoids all of
                         that: it's a normal top-of-page dropdown opening downward
                         like the desktop one, no special positioning needed. -->
                    <div class="mobile-header-currency">
                        <CurrencySelector variant="mobile" />
                    </div>
                    <div class="site-menu">
                    <ul>
                        <li>
                            <router-link to="/">Home</router-link>
                        </li>
                        <li v-for="(item, i) in header_menus" :key="i" >
                            <router-link :to="item.slug" > {{ item.title }} </router-link>
                        </li>

                        <li v-if="isAuthenticated">
                            <router-link :to="{ name: 'MobileWishlist' }" class="cartIcon-header" v-b-tooltip >
                                <span class="icon-wishlist"></span>
                                <span class="badge-cart">{{ wishlistQuantity }}</span>
                            </router-link>
                        </li>

                        <li v-if="isAuthenticated">
                            <router-link to="" class="cartIcon-header" v-b-tooltip.hover title="My Cart" >
                                <span class="icon-cart" @click="toggleSidebar"></span>
                                <span class="badge-cart"> {{ cartQuantity }}</span>
                            </router-link>
                        </li>

                        <li class="theme-toggle-item">
                            <button type="button" class="theme-toggle-btn" @click="toggleTheme" v-b-tooltip.hover :title="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'" :aria-label="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'">
                                <svg v-if="isDarkTheme" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="4.5"/><g stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="12" y1="1.5" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="22.5"/><line x1="1.5" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="22.5" y2="12"/><line x1="4.2" y1="4.2" x2="6" y2="6"/><line x1="18" y1="18" x2="19.8" y2="19.8"/><line x1="4.2" y1="19.8" x2="6" y2="18"/><line x1="18" y1="6" x2="19.8" y2="4.2"/></g></svg>
                                <svg v-else viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 1 0 11 11Z"/></svg>
                            </button>
                        </li>

                        <li class="currency-toggle">
                            <label> Currency </label>
                            <CurrencySelector variant="nav" />
                        </li>

                        <li v-if="isAuthenticated">
                            <router-link :to="{ name: 'UserDashboard' }">
                                <div class="userHead-icon logedIn">
                                    <img :src="avatar_path" :alt="user.name">
                                </div>
                            </router-link>
                        </li>
                        <li v-else>
                            <router-link to="" v-b-tooltip.hover title="Login" v-b-modal.authenticate>
                                <div class="userHead-icon">
                                    <span class="icon-login"></span>
                                </div>
                            </router-link>
                        </li>
                        <!-- <li>
                            <router-link to="" class="hightlight-btn"  v-b-modal.authenticate>Start Learning</router-link>
                        </li> -->
                    </ul>
                    </div>
                </div>
                </div>
            </div>
        </header>
        <div class="mobile-menu">
            <ul>
                <li>
                    <router-link to="/" class="highligtedMenu">
                        <span class="icon-home navIcon"></span>
                        <span class="pageName">Home</span>
                    </router-link>
                </li>
                <li v-if="isAuthenticated">
                    <router-link :to="{ name: 'MobileWishlist' }" >
                        <span class="icon-wishlist navIcon"></span>
                        <span class="badge-cart">{{ wishlistQuantity }}</span>
                    </router-link>
                </li>

                <li v-if="isAuthenticated">
                    <router-link :to="{ name: 'MobileCart' }" class="cartIcon-header">
                        <span class="icon-cart navIcon"></span>
                        <span class="badge-cart"> {{ cartQuantity }}</span>
                    </router-link>
                </li>
                <li v-if="isAuthenticated">
                    <router-link :to="{ name: 'UserDashboard' }">
                        <div class="userHead-icon logedIn">
                            <img :src="avatar_path" :alt="user.name">
                        </div>
                    </router-link>
                </li>
                <li v-else>
                    <router-link to="" v-b-tooltip.hover title="Login" v-b-modal.authenticate>
                        <div class="userHead-icon">
                            <span class="icon-login"></span>
                        </div>
                    </router-link>
                </li>
                <li @click="openBottomSheet">
                    <router-link to="" >
                        <span class="icon-menu navIcon"></span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="bottom-sheet" v-if="isBottomSheetOpen">
            <div class="sheet-overlay" @click="closeBottomSheet"></div>
            <div class="bottom-sheet-content" :class="{ 'open-bottom-sheet': isHighlighted }">
                <div @click="closeBottomSheet" class="align-items-center d-flex mb-3 authBack-wrap">
                    <span class="authBack-btn">
                        <span class="icon-arrow"></span>
                    </span> 
                    Back
                </div>
                <div class="mobile-menu-nav">
                    <ul>
                        <li v-for="(item, i) in header_menus" :key="i" @click="closeBottomSheet" >
                            <router-link :to="item.slug" > {{ item.title }} </router-link>
                        </li>
                        <li>
                            <button type="button" class="theme-toggle-row" @click="toggleTheme">
                                <span>{{ isDarkTheme ? 'Dark mode' : 'Light mode' }}</span>
                                <span class="theme-toggle-row-icon">
                                    <svg v-if="isDarkTheme" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="4.5"/><g stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="12" y1="1.5" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="22.5"/><line x1="1.5" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="22.5" y2="12"/><line x1="4.2" y1="4.2" x2="6" y2="6"/><line x1="18" y1="18" x2="19.8" y2="19.8"/><line x1="4.2" y1="19.8" x2="6" y2="18"/><line x1="18" y1="6" x2="19.8" y2="4.2"/></g></svg>
                                    <svg v-else viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 1 0 11 11Z"/></svg>
                                </span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Cart from '@/components/Cart'
import CurrencySelector from '@/components/CurrencySelector'
import { mapGetters} from "vuex";
import { ensureAuthReady } from "@/store/modules/auth";
import { fetchHeaderInfo } from "@/store/modules/settings";
export default {
  name: "SiteHeader",
  components: {
    Cart,
    CurrencySelector
  },
    data() {
        return {
            isSidebarVisible: false,
            isBottomSheetOpen: false,
            isHighlighted: false,
            header_logo: "",
            header_menus: [],
            maintenance_mode: false,
            maintenance_notice: "",
        };
    },
    computed: {
        ...mapGetters(["cartQuantity","wishlistQuantity","getTokenStatus","authenticated","user","isDarkTheme"]),
        // Reactive to the store, unlike a data() snapshot - stays correct even
        // when this component is created before the async /app-init session
        // check (kicked off in main.js) has resolved, which happens on every
        // page that doesn't have a route guard delaying its render.
        isAuthenticated() {
            return this.authenticated;
        },
        avatar_path() {
            return this.user.avatar_path;
        },
    },
    created() {
        let app = this;
        if(app.isAuthenticated){
            app.$store.dispatch("getWishlistItems", app.user.id);
        }
        ensureAuthReady(app.$store.dispatch).then((isAuthenticated) => {
            if (isAuthenticated) {
                app.$store.dispatch("getWishlistItems", app.user.id);
            }
        });
        app.$store.dispatch("fetchCountries");
    },
    mounted(){
        let app = this;
        app.renderHeaderInfo();
        app.$root.$on("cart-toggle", ($event) => {
            app.isSidebarVisible = $event;
        });
        app.updateHeaderHeightVar();
        window.addEventListener("resize", app.updateHeaderHeightVar);
    },
    beforeDestroy(){
        window.removeEventListener("resize", this.updateHeaderHeightVar);
    },
    methods: {
        // Exposes the header's real rendered height as a CSS var so pages
        // with a full-viewport scroll-snap layout (Home, About) can size
        // themselves as calc(100vh - var(--header-height)) instead of a
        // flat 90vh - which is what was pushing the page past 100vh and
        // causing the browser's own vertical scrollbar to appear.
        updateHeaderHeightVar() {
            this.$nextTick(() => {
                const headerEl = this.$el.querySelector("header");
                if (headerEl) {
                    document.documentElement.style.setProperty("--header-height", headerEl.offsetHeight + "px");
                }
            });
        },
        toggleTheme() {
            this.$store.dispatch("toggleTheme");
        },
        toggleSidebar() {
            this.isSidebarVisible = !this.isSidebarVisible;
        },
        openBottomSheet() {
            this.isBottomSheetOpen = true;
            setTimeout(() => {
                this.isHighlighted = !this.isHighlighted;
            }, 50);
        },
        closeBottomSheet() {
            this.isBottomSheetOpen = false;
            this.isHighlighted = !this.isHighlighted;
        },
        async renderHeaderInfo() {
            let app = this;
            await fetchHeaderInfo().then(function (data) {
                if (data.success) {
                    app.header_logo = data.data.header_logo;
                    app.header_menus = data.data.header_menus;
                    app.maintenance_mode = data.data.maintenance_mode;
                    app.maintenance_notice = data.data.maintenance_notice;
                }
            }).finally(function () {
                app.updateHeaderHeightVar();
            });
        },
    },
};
</script>
<style scoped>
.theme-toggle-item {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
}
.theme-toggle-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: var(--text-color);
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}
.theme-toggle-btn svg {
    width: 19px;
    height: 19px;
}
.theme-toggle-btn:hover,
.theme-toggle-btn:focus {
    background-color: var(--surface-alt-color);
    outline: none;
}
/* Mobile: the icon-only toggle used to live in the bottom tab bar, but that
   bar only has room for a handful of equally-weighted icons before it gets
   cramped on narrow screens - so on mobile the toggle instead lives as a
   labelled row inside the hamburger drawer (.mobile-menu-nav), matching the
   existing nav-link rows. */
.theme-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: transparent;
    border: 0;
    border-top: 1px solid var(--border-color-light);
    padding: 12px 10px;
    margin-top: 4px;
    color: var(--text-color);
    text-align: left;
    cursor: pointer;
}
.theme-toggle-row-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--surface-alt-color);
    color: var(--text-color);
    flex-shrink: 0;
}
.theme-toggle-row-icon svg {
    width: 16px;
    height: 16px;
}
.currency-toggle {
    display: inline-flex;
    align-items: center;
    border-left: 1px solid var(--border-color);
    padding-left: 16px;
    margin-left: 6px;
}
.currency-toggle label {
    margin: 0;
    line-height: 1;
}
/* Hidden by default (desktop shows the currency selector inside .site-menu
   instead); shown at the same 767px breakpoint where .site-menu itself
   hides, in common.css. All of the toggle button/menu styling itself now
   lives inside CurrencySelector.vue, since that's a self-contained
   component rather than a bootstrap-vue dropdown reaching into this file's
   scoped CSS. */
.mobile-header-currency {
    display: none;
    align-items: center;
}
/* Matches common.css's own .site-menu / .mobile-menu breakpoint (767px):
   swap the desktop nav for the bottom tab bar, and reveal the mobile
   header's currency selector, pinning it to the right by spacing the
   header row out (the row is otherwise left-aligned by default, since it
   normally just flows the logo then the full-width nav). */
@media (max-width: 767px) {
    /* Bootstrap 5's grid only gives .col-xl-2/.col-xl-10 their actual
       side-by-side sizing at 1200px+; below that they fall back to
       Bootstrap's blanket ".row > * { width: 100% }" rule, so both columns
       go full-width and wrap onto separate lines - logo on one, this
       column on the next. Resetting them to content-sized flex items here
       is what actually keeps the logo and the currency selector on the
       same line, side by side, instead of stacked. */
    header .container > .row {
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
    }
    header .container > .row > .col-xl-2,
    header .container > .row > .col-xl-10 {
        width: auto;
        max-width: none;
        flex: 0 0 auto;
    }
    header .container > .row > .col-xl-10 {
        display: flex;
        justify-content: flex-end;
    }
    .mobile-header-currency {
        display: flex;
    }
}
</style>
